module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/12-1f660084c42050c879155186936c5ff1.png";